import { useGetDomNodeWithInterval } from './useGetDomNodeWithInterval';
import { useGetDomNodeWithMutationObserver } from './useGetDomNodeWithMutationObserver';

export function useGetDomNode({
	selector = '', // string for ID (target-id) not with hash (#target-id)
	forceSetInterval = false,
	myDocument = undefined,
}: {
	selector: string;
	forceSetInterval: boolean;
	myDocument?: Document;
}) {
	if ('MutationObserver' in window === false || forceSetInterval) {
		return useGetDomNodeWithInterval({ selector, myDocument });
	}

	return useGetDomNodeWithMutationObserver({ selector, myDocument });
}
